import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { makeGraphRequest } from 'owa-ows-gateway';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7006 (7,22): Parameter 'uri' implicitly has an 'any' type.
// @ts-expect-error
const customFetch = (uri, options) => {
    return makeGraphRequest('/outlookgatewayb2/graphql', options.body);
};

export const remoteGraphLink = () => new BatchHttpLink({ fetch: customFetch });
